import { getLink, getButton } from '../dashboardCommon/utils';
import { orderStatus, fmFilterStatuses, roleName } from '../../utils/constant';
import { useLocaleContext } from '../../context/LocaleContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const getStatus = order => {
  const local = useLocaleContext();

  const {
    dashboardSOW: { status }
  } = local === 'en-US' ? EN : FR;

  const incomplete = order === orderStatus.incomplete;
  const pendingValidation = order === orderStatus.pendingValidation;
  const contractSend = order === orderStatus.contractSend;
  const contractSigned = order === orderStatus.contractSigned;
  const completed = order === orderStatus.submitted;
  const orderCanceled = order === orderStatus.canceled;
  const sendtoAccountManager = order === orderStatus.SendBacktoAccountManager;
  const sendBacktoSlaesRep = order === orderStatus.SendBacktoPreSalesEngineer;

  const statusList = {
    [incomplete]: status.orderIncomplete,
    [pendingValidation]: status.pendingValidation,
    [contractSend]: status.contractSent,
    [contractSigned]: status.contractSigned,
    [completed]: status.orderCompleted,
    [orderCanceled]: status.orderCanceled,
    [sendtoAccountManager]: status.sendBacktoAccountManager,
    [sendBacktoSlaesRep]: status.sendBacktoSalesRep
  };

  return statusList.true;
};

const filterValueToStatusesMap = {
  [fmFilterStatuses.incomplete]: {
    orderStatus: orderStatus.incomplete
  },
  [fmFilterStatuses.submitted]: {
    orderStatus: orderStatus.submitted
  },
  [fmFilterStatuses.pendingValidation]: {
    orderStatus: orderStatus.pendingValidation
  },
  [fmFilterStatuses.orderCanceled]: {
    orderStatus: orderStatus.canceled
  },
  [fmFilterStatuses.contractSigned]: {
    orderStatus: orderStatus.contractSigned
  },
  [fmFilterStatuses.contractSent]: {
    orderStatus: orderStatus.contractSend
  },
  [fmFilterStatuses.sendBacktoAccountManager]: {
    orderStatus: orderStatus.SendBacktoAccountManager
  },
  [fmFilterStatuses.sendBacktoSalesRep]: {
    orderStatus: orderStatus.SendBacktoPreSalesEngineer
  }
};

const getStatusFiltersPayload = filters => {
  const statuses = [];
  filters.forEach(element => {
    if (filterValueToStatusesMap[element.value]) {
      const correspondingOrderStatus =
        filterValueToStatusesMap[element.value].orderStatus;

      if (
        correspondingOrderStatus &&
        !statuses.includes(correspondingOrderStatus)
      )
        statuses.push(correspondingOrderStatus);
    }
  });
  return { status: statuses };
};

const salesRepAction = (orderStatus) => {
    return orderStatus === fmFilterStatuses.pendingValidation;
};

export {
  getLink,
  getButton,
  getStatus,
  getStatusFiltersPayload,
  salesRepAction
};
